import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * VA-29073: "Question 3 of 8 · Extra questions: 2", next to the interview timer
 * and in the code editor header, so the candidate can pace themselves. Renders
 * nothing until the server has sent a count (and never in realtime mode).
 */
import { ListChecks } from 'lucide-react';
import { extraLabel, plannedLabel } from '@/context/question-progress';
const QuestionProgressPill = ({ progress, tone = 'light', }) => {
    if (!progress)
        return null;
    const planned = plannedLabel(progress);
    const extra = extraLabel(progress);
    if (!planned && !extra)
        return null;
    const box = tone === 'dark'
        ? 'border-white/15 bg-white/5 text-slate-100'
        : 'border-white/10 bg-black/55 text-white backdrop-blur';
    return (_jsxs("div", { role: 'status', "aria-live": 'polite', "data-testid": 'question-progress', className: `inline-flex items-center gap-2 rounded-lg border px-2.5 py-1 text-xs font-medium ${box}`, children: [_jsx(ListChecks, { className: 'h-3.5 w-3.5 shrink-0 opacity-80', "aria-hidden": 'true' }), planned && _jsx("span", { className: progress.currentIsExtra ? 'opacity-70' : undefined, children: planned }), planned && extra && _jsx("span", { className: 'opacity-50', children: "\u00B7" }), extra && _jsx("span", { className: progress.currentIsExtra ? undefined : 'opacity-70', children: extra })] }));
};
export default QuestionProgressPill;
